import React, { useState } from "react";
import { LuChevronLeft } from "react-icons/lu";
import AddressIllustrationLogoIcon from "../icons/AddressIllustrationLogoIcon";
import ChangePasswordIllustrationLogoIcon from "../icons/ChangePasswordIllustrationLogoIcon";
import DeleteAccountIllustrationLogoIcon from "../icons/DeleteAccountIllustrationLogoIcon";
import DocumentsIllustrationLogoIcon from "../icons/DocumentsIllustrationLogoIcon";
import EmailIllustrationLogoIcon from "../icons/EmailIllustrationLogoIcon";
import PhoneNumberIllustrationLogoIcon from "../icons/PhoneNumberIllustrationLogoIcon";
import AccountAccessPanel from "./accountSettings/AccountAccessPanel";
import AccountSettingsHome from "./accountSettings/AccountSettingsHome";
import AddressPanel from "./accountSettings/AddressPanel";
import DeleteAccountPanel from "./accountSettings/DeleteAccountPanel";
import UserInformationPanel from "./accountSettings/UserInformationPanel";
import VendorLayout from "./VendorLayout";
import SettingsIcon from "../icons/SettingsIcon";
import { translateLabel, useTranslationSnapshot } from "./../translations/runtime";


const initialUserInfo = {
  firstName: "Khaled",
  lastName: "Romeh",
  gender: "Male",
  birthdate: "",
};

function VendorAccountSettings() {
  useTranslationSnapshot();
  const [activePanel, setActivePanelState] = useState("menu");
  const [accountAccessStep, setAccountAccessStepState] = useState("list");
  const [accountAccessBackSignal, setAccountAccessBackSignal] = useState(0);
  const [addressBackSignal, setAddressBackSignal] = useState(0);

  const isUserInfo = activePanel === "user-info";
  const isAccountAccess = activePanel === "account-access";
  const isAddress = activePanel === "address";
  const isDeleteAccount = activePanel === "delete-account";
  const isDetailPanel =
    isUserInfo || isAccountAccess || isAddress || isDeleteAccount;
  const isPhoneStep = accountAccessStep.startsWith("phone");
  const isPasswordStep = accountAccessStep.startsWith("password");

  const setActivePanel = (panel) => {
    setActivePanelState(panel);
  };

  const setAccountAccessStep = (step) => {
    setAccountAccessStepState(step);
  };

  const goBack = () => {
    if (isAddress) {
      setAddressBackSignal((current) => current + 1);
      return;
    }

    if (isAccountAccess && accountAccessStep !== "list") {
      setAccountAccessBackSignal((current) => current + 1);
      return;
    }

    setActivePanel("menu");
  };

  const handleDeleteAccount = () => {
    // Existing/backend delete-account integration goes here.
  };

  return (
    <VendorLayout activeKey="account-settings">
      <main className="vendor-account-settings-screen">
        <div className="vendor-account-settings-hero">
          {isDeleteAccount ? (
            <DeleteAccountIllustrationLogoIcon
              className="vendor-delete-account-illustration"
              height={197}
              width={199}
            />
          ) : activePanel === "menu" ? (
            <SettingsIcon
              className="vendor-account-settings-address-illustration"
              height={196}
              width={189}
            />
          ) : isAddress ? (
            <AddressIllustrationLogoIcon
              className="vendor-account-settings-address-illustration"
              height={196}
              width={189}
            />
          ) : isPasswordStep ? (
            <ChangePasswordIllustrationLogoIcon
              className="vendor-account-settings-password-illustration"
              height={203}
              width={165}
            />
          ) : isPhoneStep ? (
            <PhoneNumberIllustrationLogoIcon
              className="vendor-account-settings-phone-illustration"
              height={191}
              width={190}
            />
          ) : isAccountAccess ? (
            <EmailIllustrationLogoIcon
              className="vendor-account-settings-email-illustration"
              height={258}
              width={210}
            />
          ) : isUserInfo ? (
            <DocumentsIllustrationLogoIcon
              className="vendor-account-settings-illustration"
              height={172}
              width={300}
            />
          ) : (
            <span aria-hidden="true" />
          )}
        </div>

        <section
          className={`vendor-account-settings-panel${
            isDetailPanel ? " vendor-account-settings-panel-detail" : ""
          }${isDeleteAccount ? " vendor-delete-account-panel" : ""}`}
        >
          {!isDeleteAccount ? (
            <header className="vendor-account-settings-header">
              {activePanel !== "menu" ? (
                <button
                  aria-label={translateLabel("txt_web_vendor_back", "Back")}
                  className="vendor-account-settings-back"
                  onClick={goBack}
                  type="button"
                >
                  <LuChevronLeft className="navigation-direction-icon" aria-hidden="true" />
                </button>
              ) : null}
              <h1>
                {isDetailPanel
                  ? translateLabel("lnk_account_settings", "Account Settings")
                  : translateLabel("txt_web_vendor_account_settings_user_profile", "Account Settings / User Profile")}
              </h1>
            </header>
          ) : null}

          {isAccountAccess ? (
            <AccountAccessPanel
              backSignal={accountAccessBackSignal}
              initialStep={accountAccessStep}
              onGoHome={() => setActivePanel("menu")}
              onStepChange={setAccountAccessStep}
            />
          ) : isUserInfo ? (
            <UserInformationPanel initialUserInfo={initialUserInfo} />
          ) : isAddress ? (
            <AddressPanel
              backSignal={addressBackSignal}
              onGoHome={() => setActivePanel("menu")}
            />
          ) : isDeleteAccount ? (
            <DeleteAccountPanel
              onCancel={() => setActivePanel("menu")}
              onDelete={handleDeleteAccount}
            />
          ) : (
            <AccountSettingsHome onSelect={setActivePanel} />
          )}
        </section>
      </main>
    </VendorLayout>
  );
}

export default VendorAccountSettings;
